import { createReducer } from "@reduxjs/toolkit";
import { IDashboardLinkState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: [],
  state: StoreState.None,
} as IDashboardLinkState;

export const dashboardLinkReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.dashboardLinkFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.dashboardLinkFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.dashboardLinkFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
